:host{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:none}:host.screen-drawing--enabled{content:" ";position:absolute;border:.1rem dashed #0091d5}
/*# sourceMappingURL=screen-drawing.component-GUD6HVSX.css.map */
